import { STATUS_IT } from "@/lib/format";

const STYLES = {
  pending: "border-gold/70 text-[#8a6a2f] bg-gold/10",
  confirmed: "border-sage/60 text-sage-deep bg-sage/10",
  cancelled: "border-destructive/40 text-destructive bg-destructive/5",
  completed: "border-wood/40 text-wood bg-wood/5",
  "no-show": "border-wood/30 text-wood/60 bg-transparent",
};

export function StatusBadge({ status, testId }) {
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center border px-2.5 py-1 text-[0.62rem] uppercase tracking-[0.16em] ${
        STYLES[status] || STYLES.pending
      }`}
    >
      {STATUS_IT[status] || status}
    </span>
  );
}

export default StatusBadge;
